import React, { useEffect, useState } from "react";
import axios from "axios";

const DeliveryReportList = () => {
  const [reports, setReports] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/list_delivery_reports`)
      .then((res) => {
        if (res.data.status === "success") {
          setReports(res.data.files);
        }
      })
      .catch((err) => console.error("Error loading reports:", err));
  }, []);

  return (
    <div
      style={{
        maxWidth: "700px",
        marginTop: "30px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h6 style={{ marginBottom: "15px", textAlign: "center" }}>
        Delivery Reports <br />
        (डिलीवरी रिपोर्ट्स)
      </h6>

      {reports.length === 0 ? (
        <p style={{ textAlign: "center" }}>No reports found.</p>
      ) : (
        <div
          style={{
            maxHeight: "400px",
            overflowY: "auto",
            border: "1px solid #ddd",
            borderRadius: "6px",
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none", // IE, Edge
          }}
          className="hide-scrollbar"
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              boxShadow: "0 0 5px rgba(0,0,0,0.1)",
            }}
          >
            <tbody>
              {reports.map((r, i) => (
                <tr key={i} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={{ padding: "8px", fontSize: "10pt" }}>
                    {r.filename}
                  </td>
                  <td style={{ padding: "8px", fontSize: "10pt" }}>
                    {r.date}
                  </td>
                  <td style={{ textAlign: "center", padding: "8px" }}>
                    <button
                      onClick={() => window.open(r.url, "_blank")}
                      style={{
                        backgroundColor: "#2f506c",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        padding: "5px 10px",
                        cursor: "pointer",
                      }}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DeliveryReportList;
